"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.onFocus = void 0;
const focusManager_1 = require("../managers/focusManager");
const tabNavigation_1 = require("../navigation/tabNavigation");
const gamepad_1 = require("./gamepad");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const onFocus = (event) => {
    if (!(0, gamepad_1.shouldHandleGamepadInput)()) {
        return;
    }
    (0, tabNavigation_1.onTabFocusEvent)(event);
    if ((document === null || document === void 0 ? void 0 : document.activeElement) instanceof HTMLElement) {
        (0, focusManager_1.handleManualFocus)(document === null || document === void 0 ? void 0 : document.activeElement);
    }
};
exports.onFocus = onFocus;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9jdXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29yZS9mb3VuZGF0aW9uL2ZvY3VzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUU1RCwyREFBNkQ7QUFDN0QsK0RBQThEO0FBQzlELHVDQUFxRDtBQUVyRCw2REFBNkQ7QUFDdEQsTUFBTSxPQUFPLEdBQUcsQ0FBQyxLQUFpQixFQUFFLEVBQUU7SUFDekMsSUFBSSxDQUFDLElBQUEsa0NBQXdCLEdBQUUsRUFBRSxDQUFDO1FBQzlCLE9BQU87SUFDWCxDQUFDO0lBRUQsSUFBQSwrQkFBZSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBRXZCLElBQUksQ0FBQSxRQUFRLGFBQVIsUUFBUSx1QkFBUixRQUFRLENBQUUsYUFBYSxhQUFZLFdBQVcsRUFBRSxDQUFDO1FBQ2pELElBQUEsZ0NBQWlCLEVBQUMsUUFBUSxhQUFSLFFBQVEsdUJBQVIsUUFBUSxDQUFFLGFBQWEsQ0FBQyxDQUFDO0lBQy9DLENBQUM7QUFDTCxDQUFDLENBQUM7QUFWVyxRQUFBLE9BQU8sV0FVbEIifQ==